import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';

import { createVuetify } from 'vuetify';
import { VOtpInput } from 'vuetify/components';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

const vuetify = createVuetify({
  components: {
    VOtpInput,
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'default',
    themes: {
      default: {
        dark: true,
        colors: {
          primary: '#1CB0B3',
          'primary-light': '#7ce8ea',
          'primary-lighter': '#bdf3f4',
          'app-background': '#101314',
          'app-background-soft': '#151a1c',
          'site-chrome': '#111416',
          'dark-background': '#171c1e',
          surface: '#1c2224',
          'surface-light': '#222a2d',
          'on-primary': '#ffffff',
          secondary: '#909090',
          accent: '#ffc107',
          error: '#f44336',
          warning: '#e7802d',
          info: '#03a9f4',
          success: '#4caf50',
        },
      },
    },
  },
});

export default vuetify;
